import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Stack, Alert, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import useIsMountedRef from '../../../../shared/hooks/useIsMountedRef';
import useCreateSupportTicketModal from '../../../hooks/useCreateSupportTicketModal';
import { FormProvider, RHFTextField } from '../../../../shared/components/hook-form';

CreateSupportTicketModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default function CreateSupportTicketModal({ open = false, onClose }) {
  const isMountedRef = useIsMountedRef();
  const { handleCreateSupportTicket } = useCreateSupportTicketModal();

  const CreateSupportTicketModalSchema = Yup.object().shape({
    message: Yup.string().required('Message is required'),
  });

  const methods = useForm({
    resolver: yupResolver(CreateSupportTicketModalSchema),
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const onSubmit = async (formData) => {
    try {
      handleCreateSupportTicket(formData);

      onClose();
    } catch (error) {
      console.error(error);

      reset();

      if (isMountedRef.current) {
        setError('afterSubmit', {
          ...error,
          message: error.message,
        });
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Create Support Ticket</DialogTitle>

      <DialogContent>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

          <Stack
            spacing={2}
            sx={{
              mt: 3,
            }}
          >
            <RHFTextField name="message" label="Message" minLines={3} />

            <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
              Send
            </LoadingButton>
          </Stack>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
